const formatNumber = (number, type) => {
    return type === "digit" ? number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") : Number(number).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export default formatNumber;
